import { ERROR_FIELDS } from '../types';
const isFieldViolated = (error, fieldName) => {
  var _error$errorDetails;
  const violations = error == null || (_error$errorDetails = error.errorDetails) == null || (_error$errorDetails = _error$errorDetails.validationError) == null ? void 0 : _error$errorDetails.fieldViolations;
  return !!violations && violations.some(v => v && v.field === fieldName);
};
export const deliverySolutionsErrorsMapper = errors => {
  var _noShippingExternalEr;
  const checkForError = field => (errors == null ? void 0 : errors.some(error => isFieldViolated(error, field))) ?? false;
  const noShippingExternalError = errors == null ? void 0 : errors.find(error => {
    var _error$errorDetails2;
    return ((_error$errorDetails2 = error.errorDetails) == null || (_error$errorDetails2 = _error$errorDetails2.applicationError) == null ? void 0 : _error$errorDetails2.code) === 'NO_SHIPPING';
  });
  const externalCarrierError = noShippingExternalError ? {
    message: (_noShippingExternalEr = noShippingExternalError.errorDetails) == null || (_noShippingExternalEr = _noShippingExternalEr.applicationError) == null ? void 0 : _noShippingExternalEr.description
  } : undefined;
  return {
    externalCarrierError,
    hasShippingZipCodeError: checkForError(ERROR_FIELDS.POSTAL_CODE),
    hasShippingDestinationError: checkForError(ERROR_FIELDS.SHIPPING_DESTINATION),
    hasShippingSubdivisionError: checkForError(ERROR_FIELDS.SHIPPING_DESTINATION_SUBDIVISION)
  };
};
//# sourceMappingURL=deliverySolutionsErrorsMapper.js.map